import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateComponent extends InputComponent {
    clear = output<void>();

    public onClear() {
        this.formControl()?.setValue('')
        this.clear?.emit();
    }
}
